export const mathSign = (val) => (val !== 0 ? (val / Math.abs(val)) : 0);

export const sign = (val) => {
    let s = mathSign(val);

    if (s === 0) s = 0.7;

    return s;
};
